/* eslint-disable no-undef */
//var Turbolinks = require('turbolinks')
//Turbolinks.start()

/** anchor animation **/
function goUpVisible() {
  var go = $('.go')
  var goBack = $('.go--back')
  var seznamLikeButtonWrapper = $('.article__seznam-like-button')
  if ($(document).scrollTop() > $(window).height() / 3) {
    if (document.referrer.includes('golfovinky.cz') === false) {
      goBack.css('opacity', 0)
    }
    seznamLikeButtonWrapper.addClass('article__seznam-like-button--visible')
    go.addClass('go--visible')
  } else {
    seznamLikeButtonWrapper.removeClass('article__seznam-like-button--visible')
    go.removeClass('go--visible')
  }
}

function stickyNav() {
  var toolbar = $('.toolbar')
  var toolbarLinks = $('.toolbar__links')
  var webBanner = $('.web-banner-mobile')

  if ($(document).scrollTop() > $('.header__nav').offset().top) {
    toolbar.addClass('toolbar--sticky')
    toolbarLinks.addClass('no-transition')
    if ($(document).scrollTop() > $('.header__nav').offset().top + 30) {
      toolbarLinks.removeClass('no-transition')
      toolbarLinks.removeClass('no-transition')
      webBanner.css('opacity', 1)
    }
  } else {
    toolbarLinks.removeClass('no-transition')
    toolbar.removeClass('toolbar--sticky')
    webBanner.css('opacity', 0)
  }
}
$(window).on('scroll', function () {
  goUpVisible()
  stickyNav()
})

$(window).on('resize', function () {
  goUpVisible()
  stickyNav()
})

$(function () {
  goUpVisible()
  stickyNav()

  $('body').removeClass('before-render')

  $('.go--up').on('click', function (event) {
    if ($(this.hash).length) {
      event.preventDefault()
      $('html,body').animate(
        { scrollTop: $(this.hash).offset().top - 70 },
        1000
      )
    } else {
      return true
    }
  })

  $('.navbar-item a').on('click', function () {
    $('.navbar-item a').not(this).removeClass('active')
    $(this).addClass('active')
  })

  $('.toolbar__logo, .header__top__logo').on('click', function () {
    $('.navbar-item a').removeClass('active')
  })
})

window.onload = function () {
  document.body.classList.add('loaded')
}
